import { PercPickupLocation } from '../../../graphql';

export const getPrettyPickupLocation = (
	pickupLocation: PercPickupLocation
): string => {
	switch (pickupLocation) {
		case 'IN_STORE':
			return 'At store';

		case 'DRIVE_THRU':
			return 'At drive-thru';

		case 'PARKING_LOT':
			return 'In parking lot';
		default:
			return 'Somewhere...';
	}
};
